import script from "./CompanyAdminRegionDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyAdminRegionDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CompanyAdminRegionDrawer.vue?vue&type=style&index=0&id=4478cac5&scoped=true&lang=css"
import "./CompanyAdminRegionDrawer.vue?vue&type=style&index=1&id=4478cac5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4478cac5"]])

export default __exports__